import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onAutomationRulesDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onAutomationRulesDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="automationRule"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onAutomationRulesDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
